(function () {
    function findPosX(obj) {
        let curleft = 0;
        if (obj.offsetParent) {
            while (1) {
                curleft += obj.offsetLeft;
                if (!obj.offsetParent) { break; }
                obj = obj.offsetParent;
            }
        } else if (obj.x) { curleft += obj.x; }
        return curleft;
    }

    function findPosY(obj) {
        let curtop = 0;
        let oldPos = '';
        if (obj.offsetParent) {
            while (1) {
                if ((obj.tagName == 'A') && navigator.appVersion.indexOf('MSIE') != -1) {
                    oldPos = obj.style.height;
                    obj.style.height = 'auto';
                } else if ((obj.tagName == 'LI') && navigator.appVersion.indexOf('MSIE') != -1) {
                    oldPos = obj.style.position;
                    obj.style.position = 'relative';
                }
                curtop += obj.offsetTop;
                if ((obj.tagName == 'A') && navigator.appVersion.indexOf('MSIE') != -1) obj.style.height = oldPos;
                else if ((obj.tagName == 'LI') && navigator.appVersion.indexOf('MSIE') != -1) obj.style.position = oldPos;

                if (!obj.offsetParent) { break; }
                obj = obj.offsetParent;
            }
        } else if (obj.y) { curtop += obj.y; }
        return curtop;
    }

    // Only used in faqPopup.js?
    window.findPos = function (obj) {
        return [findPosX(obj), findPosY(obj)];
    };
})();
